function Tabs(){

    console.log("Tabs");

    var self = this;

    if(window.location.hash) {

        var url = window.location.href;

        var hash = url.split('#')[1];

        console.log("url " + url);

        console.log("hash " + hash);

        // change hash

        self.setActiveTab(hash);
        self.setActiveContent(hash);

    } else {


        console.log("no hash ");

    }

    $(".tabs a").click(function(e) {

        console.log("----------- click");

        e.preventDefault();

        var id = $(this).data('content');

        console.log("id " + id);

        self.setActiveTab(id);

        self.setActiveContent(id);

    });




}

Tabs.prototype.setActiveTab = function (h){

    var self = this;

    var activeLinkID = h + "-link";

   // console.log("activeLinkID " + activeLinkID);

    $('.tabs a').each(function(index, element){

       // $(this).removeClass("active");

        var id = $(this).attr('id');

        if (activeLinkID === id){

            $(this).addClass("active");

           // console.log("class added to " + id);

        } else {

            $(this).removeClass("active");

            //console.log("class removed from " + id);

        }

    });



};

Tabs.prototype.setActiveContent = function (h){

    var self = this;

    var activeSectionID = "#" + h;

    console.log("activeSectionID " + activeSectionID);

    $('.section').removeClass("active");

    $(activeSectionID).addClass("active");


};




